"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Builder = _interopRequireDefault(require("./Builder"));
var _settings = require("./Builder/settings.js");
var _Player = _interopRequireDefault(require("./Player"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = {
  code: 'block',
  name: 'Block',
  labelField: 'name',
  icon: _settings.icon,
  builder: _Builder["default"],
  builderInitialValues: _settings.initialValues,
  player: _Player["default"],
  isStaticPlayer: true,
  isAdult: true,
  skipPlaying: true,
  selectChildren: _settings.selectChildren,
  previewButtons: ['undo', 'redo', 'preview', 'duplicate', 'export', 'delete']
};